import React from 'react';
import { useDispatch } from 'react-redux';
import { showToast } from '../../../helpers/toastHelper';

import OvalContentsNew from './OvalContentsNew';

const WrappedOvalContentsNew = props => {
  const dispatch = useDispatch();

  return <OvalContentsNew {...props} showToast={showToast(dispatch)} />;
};

export default WrappedOvalContentsNew;



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_openscap-5.2.2-2.fm3_3.el8.noarch/usr/share/gems/gems/foreman_openscap-5.2.2/webpack/routes/OvalContents/OvalContentsNew/index.js